<script setup>
import LessonsTable from "./lessons/LessonsTable.vue";
import PanelSearch from "@/apps/player/panel/PanelSearch.vue";
import LessonsStats from "@/apps/player/panel/lessons/LessonsStats.vue";
import { computed, onMounted, ref } from "vue";
import { useAsyncState } from "@vueuse/core";
import { playerStatsService } from "@/apps/player/services/player-stats.service";
import { useRoute } from "vue-router";

const query = ref("");
const {
    state: lessons,
    isLoading,
    execute,
} = useAsyncState(
    ({ uuid } = {}) =>
        playerStatsService.getLessons(uuid).then((lessons) =>
            lessons.map((l) => ({
                ...l,
                link: `/players/${uuid}?file=${l.id}`,
            }))
        ),
    [],
    { immediate: false }
);
const filteredLessons = computed(() =>
    lessons.value.filter((f) => f.name.toLowerCase().includes(query.value.toLowerCase()))
);
const { params } = useRoute();
const playerUUID = computed(() => params.projectUuid);

onMounted(() => execute(0, { uuid: playerUUID.value }));
</script>

<template>
    <LessonsStats />

    <PanelSearch
        v-model="query"
        :linkToPlayer="`/players/${playerUUID}`"
        :placeholder="$t('player.panel.lessons.search')"
    />
    <LessonsTable :lessons="filteredLessons" :isLoading="isLoading" :searchQuery="query" />
</template>
